<!--
 * @version: V1.0.0
 * @Date: 2023-08-14 16:25:54
 * @LastEditors: lzq
 * @LastEditTime: 2024-01-30 09:39:24
 * @company: 睿展数据
 * @FilePath: \udi-wms-client\src\views\realTimeInventory\components\cancelCodeList.vue
 * @Descripttion:
-->
<!--  -->
<template>
  <el-drawer v-loading.fullscreen="loading" :visible="visible" size="70%" :destroy-on-close="true"
    :wrapper-closable="false" :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
    <div slot="title" style="display: flex;justify-content: space-between;">
      <div>查看</div>
      <div>
        <el-button @click="$emit('close')"> 返回 </el-button>
      </div>
    </div>
    <el-card class="udi-form group-box no-border" shadow="never">
      <el-form ref="form" label-width="110px" label-suffix="：">
        <div class="box-title">产品信息</div>
        <div class="gird-container">
          <el-form-item label="物料名称">
            <div class="form-content" :title="inventoryInfo.materialName">{{ inventoryInfo.materialName }}</div>
          </el-form-item>
          <el-form-item label="物料规格型号">
            <div class="form-content" :title="inventoryInfo.specification">{{ inventoryInfo.specification }}</div>

          </el-form-item>
          <el-form-item label="包装级别">
            <div class="form-content" :title="inventoryInfo.packLevel"> {{ inventoryInfo.packLevel }}</div>
          </el-form-item>
          <el-form-item label="库存数量">
            <div class="form-content" :title="inventoryInfo.number"> {{ inventoryInfo.number }}</div>
          </el-form-item>
          <el-form-item label="冻结数">
            <div class="form-content" :title="inventoryInfo.freezeNumber"> {{ inventoryInfo.freezeNumber }}</div>
          </el-form-item>
          <el-form-item label="批号" :title="inventoryInfo.batchNumber">
            <div class="form-content"> {{ inventoryInfo.batchNumber }}</div>
          </el-form-item>
          <el-form-item label="失效日期" :title="inventoryInfo.expiryDate">
            <div class="form-content">
              {{ inventoryInfo.expiryDate ? parseTime(inventoryInfo.expiryDate, '{y}-{m}-{d}') : null }}

            </div>
          </el-form-item>
          <el-form-item label="生产日期" :title="inventoryInfo.prodDate">
            <div class="form-content">
              {{ inventoryInfo.prodDate ? parseTime(inventoryInfo.prodDate, '{y}-{m}-{d}') : null }}
            </div>
          </el-form-item>
          <el-form-item label="码类型">
            <div class="form-content">
              {{ isSingle ? '唯一码' : '批次码' }}
            </div>
          </el-form-item>
          <!-- 批次码才展示UDI码  -->
          <el-form-item  v-if="!isSingle" style="grid-column: span 4;" label="UDI码">
            {{ dataList.length>0?dataList[0].code:'' }}
          </el-form-item>
        </div>

        <template>
          <div class="box-title">出入库记录</div>
          <div style="display: flex;justify-content: space-between">
            <div>
              <el-button v-if="$btnsPermission('realTimeInventory:zf')" size="mini" type="primary" @click="handleInvalid">
                作废UDI码
              </el-button>
            </div>

            <div style="display: flex">
              <el-select clearable v-model="searchParam.state" placeholder="请选择" style="width: 200px;display: flex">
                <el-option v-for="dict in dictObj.receiptDeliveryState"
                           :key="dict.dictValue" :label="dict.dictLabel" :value="dict.dictValue">
                </el-option>
              </el-select>

              <el-input v-model.trim="searchParam.code" placeholder="UDI码" clearable style="width: 300px">
              </el-input>
              <div style="margin-left: 8px">
                <el-button size="mini" type="primary" @click="getList">
                  搜索
                </el-button>
                <el-button size="mini"  @click="reset">
                  重置
                </el-button>
              </div>
            </div>
          </div>
          <br/>
          <el-table ref="dataTable" align="center" v-loadlog="loading"  :data="dataList" border @selection-change="handleSelectionChange">
            <el-table-column type="selection" :selectable='selectInit' width="55">
            </el-table-column>
            <el-table-column show-overflow-tooltip min-width="200" prop="code" label="UDI码" />
            <el-table-column show-overflow-tooltip width="150px" prop="inCode" label="入库单" />
            <el-table-column show-overflow-tooltip width="160px" prop="createTime" label="入库时间">
              <template slot-scope="{row }">
                {{ row.createTime ? parseTime(row.createTime) : null }}
              </template>
            </el-table-column>
            <el-table-column v-if="!isSingle" prop="number" label="数量" width="130">
              <template slot-scope="{row }">
                {{ inventoryInfo.number }}
              </template>
            </el-table-column>
            <el-table-column v-if="isSingle" show-overflow-tooltip min-width="150px" prop="outCode" label="出库单" >
              <template slot-scope="{row }">
                {{ row.state==='KY' ? null : row.outCode }}
              </template>
            </el-table-column>
            <el-table-column v-if="isSingle" show-overflow-tooltip min-width="160px" prop="outTime" label="出库时间">
              <template slot-scope="{row }">
                {{ row.state==='KY' ? null : row.outTime ? parseTime(row.outTime) : null }}
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip min-width="120px" prop="state" label="状态">
              <template slot-scope="scope">
                <dict-tag :options="dictObj.receiptDeliveryState" :value="scope.row.state" />
              </template>
            </el-table-column>
          </el-table>
          <pagination v-show="searchParam.total > 0" :total="searchParam.total" :page.sync="searchParam.pageNum"
            :limit.sync="searchParam.pageSize" :page-sizes="[10,50,500,1000]" @pagination="getList" />
        </template>

      </el-form>
    </el-card>
    <InvalidUdiDialog
      v-if="invalidShow"
      :visible="invalidShow"
      :list="selectList"
      :is-batch-code="!isSingle"
      @close="close"
      @getList="getList"
    />
  </el-drawer>
</template>

<script>
import { getInvertoryRecordsDetail } from '@/api/invertory'
import InvalidUdiDialog from "@/views/outboundManage/components/previewUdi/InvalidUdiDialog.vue";
import { f } from "vue-print-nb/lib/print.common";

export default {
  name: 'DetialInventory',
  components: { InvalidUdiDialog},
  props: {
    visible: {
      type: Boolean,
      default() {
        return false
      }
    },
    inventoryInfo: {
      type: Object,
      default() {
        return {}
      }
    },
    dictObj: {
      type: Object,
      default() {
        return {
          receiptDeliveryState: []
        }
      }
    }
  },
  data() {
    // 这里存放数据
    return {
      invalidShow: false,
      selectList: [],// 选中列表

      loading: false,
      dataList: [],
      searchParam: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
        code:'',
        state:''
      }
    }
  },
  computed: {
    isSingle() {
      if(this.dataList.length>0){
        return this.dataList[0] ?    this.dataList[0].code.indexOf('(21)') !== -1: false
      }else {
        return true
      }
    }
  },
  created() {
    this.searchParam = Object.assign(this.$data.searchParam, this.$options.data.call(this)).searchParam
    if (this.inventoryInfo.id) {
      this.getList(this.inventoryInfo)
    }
  },
  // 方法集合
  methods: {
    close() {
      this.invalidShow=false
      if(!this.isSingle){
        this.$emit('close')
      }
    },
    selectInit(row,index){
      if(row.state==='KY'){    //判断条件
        return true  //可勾选
      }else{
        return false  //不可勾选
      }
    },
    // 处理udi作废
    handleInvalid() {
      if (this.selectList.length === 0) {
        this.$message({type: 'warning', message: '请选择要报废的UDI码!'})
        return false
      } else {
        this.invalidShow = true;
        // this.$confirm('确认作废选中的UDI码吗?', '提示', {
        //   confirmButtonText: '确定',
        //   cancelButtonText: '取消',
        //   type: 'warning'
        // }).then(() => {
        //   this.loading = true
        //   handleInvalidUdiCode(this.selectList).then(() => {
        //     this.$message({type: 'success', message: '操作成功!'})
        //     this.getList()
        //   }).finally(() => {
        //     this.loading = false
        //   })
        // })
      }
    },

    handleSelectionChange(valList) {
      this.selectList = valList
    },

    // 重置查询
    reset() {
      this.searchParam = Object.assign(this.$data.searchParam, this.$options.data.call(this)).searchParam
      this.getList()
    },
    // 获取出入库记录
    getList() {
      this.loading=true
      getInvertoryRecordsDetail({ stockId: this.inventoryInfo.id, ...this.searchParam }).then((res) => {
        this.dataList = res.rows
        this.searchParam.total = res.total
        this.loading=false
      }).catch(ex=>{
        this.loading=false
      })
    },
  }
}
</script>

<style scoped>
.gird-container {
  display: grid;
  grid-template-columns: repeat(4, 25%);
}

.form-content {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
